import React from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import ErrorBox from '../../../general/ErrorBox'
import ImagesMovieDisplayAndUploadList from './ImagesMovieDisplayAndUploadList'

const ImagesMovieDisplayAndUploadComponent = ({
    images,
    movieTitle,
    isDisabled,
    isUploading,
    errorMessages,
    onUploadStart,
    imageType,
    onUploadEndSuccess,
    onUploadEndError,
    onResetErrorMessages,
    setMovieImages,
})  => {
    return (
        <DndProvider backend={HTML5Backend}>
            <React.Fragment>
                {isUploading && <div className='overlay'>
                    <div className="spinner"></div>
                </div>}

                <ImagesMovieDisplayAndUploadList
                    dndItems={images}
                    movieTitle={movieTitle}
                    isUploading={isUploading}
                    isDisabled={isDisabled}
                    imageType={imageType}
                    onUploadStart={onUploadStart} 
                    onUploadEndSuccess={onUploadEndSuccess}
                    onUploadEndError={onUploadEndError}
                    onResetErrorMessages={onResetErrorMessages}
                    setMovieImages={setMovieImages}
                />

                <ErrorBox messages={errorMessages} />
            </React.Fragment>
        </DndProvider>
    )
}


export default ImagesMovieDisplayAndUploadComponent